import { SET_BUSINESS, SET_BUSINESSES } from "../../constants/businessConstants";

export const setBusiness = (business) => {
  return {
    type: SET_BUSINESS,
    business,
  };
};

export const setBusinesses = (businesses, filtered = false) => {
  return {
    type: SET_BUSINESSES,
    businesses,
    filtered,
  };
};